export default __webpack_public_path__ + "static/media/zkSync BCO.b1171fc0.svg";